import type { IMessage } from "~contexts/Socket/interfaces";
import type { Dayjs } from "dayjs";

const addMessageAtGroup = (map: any, message: IMessage) => {
  const { privateRoom: groupId } = message;
  const roomMessages = map.get(groupId);
  const messagesSet = roomMessages ?? new Set();

  messagesSet.add(message);

  map.set(groupId, messagesSet);
};

const orderMessagesByDescendingTime = (msgs: IMessage[]) => {
  return msgs.sort((a, b) => {
    const today = new Date();
    let aTime = new Date(a.time).getTime();
    let bTime = new Date(b.time).getTime();

    const aTimeIsInvalid = Number.isNaN(aTime);
    const bTimeIsInvalid = Number.isNaN(bTime);

    aTime = aTimeIsInvalid
      ? new Date(`${today.toDateString()} ${a.time}`).getTime()
      : aTime;
    bTime = bTimeIsInvalid
      ? new Date(`${today.toDateString()} ${b.time}`).getTime()
      : bTime;

    return aTime - bTime;
  });
};

const orderMessages = (messagesArray: IMessage[]) => {
  const orderedMessages = orderMessagesByDescendingTime(messagesArray);
  return orderedMessages;
};

const groupMessagesByUser = (messages: IMessage[]) => {
  const mapOfmessagesByUser = new Map();

  messages.forEach((item) => addMessageAtGroup(mapOfmessagesByUser, item));

  return mapOfmessagesByUser;
};

const getRoomsWithOperatorsLastMessage = (currMap: any, message: IMessage) => {
  try {
    const mapOfRooms = new Map(currMap);
    addMessageAtGroup(mapOfRooms, message);
    return mapOfRooms;
  } catch (e) {
    console.error("this function accepts only Map as currMap param");
    return currMap;
  }
};

const convertToHour = (date: string) => {
  let hour = new Date(date).getHours().toString();
  let minutes = new Date(date).getMinutes().toString();
  hour = ("0" + hour).slice(-2);
  minutes = ("0" + minutes).slice(-2);

  return hour + ":" + minutes;
};

const getMessagesWithId = (messagesArr: IMessage[]) =>
  messagesArr.map((message) => ({
    ...message,
    id: message.time + message.email,
  }));

const convertDayJsInDate = (value: Dayjs | null): string => {
  if (!value) return "";

  const year = value.year();
  const day = value.date().toLocaleString("PT-BR", { minimumIntegerDigits: 2 });
  const month = (value.month() + 1).toLocaleString("PT-BR", {
    minimumIntegerDigits: 2,
  });

  return `${year}-${month}-${day}`;
};

export {
  orderMessagesByDescendingTime,
  orderMessages,
  groupMessagesByUser,
  getRoomsWithOperatorsLastMessage,
  convertToHour,
  getMessagesWithId,
  convertDayJsInDate,
};
